import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as get from 'lodash/get';

import { BpasEngagement } from '../../domain';
import * as fromEngagements from './engagements.reducer';

export const engagementsKey = 'engagementPortfolios';

const getEngagementsState = createFeatureSelector<fromEngagements.EngagementsState>(
	engagementsKey
);

export const selectEngagementsIsLoading = createSelector(
	getEngagementsState,
	fromEngagements.getIsLoading
);

export const selectEngagementsIsUpdating = createSelector(
	getEngagementsState,
	fromEngagements.getIsUpdating
);

export const getSpecifiedEngagementId = createSelector(
	getEngagementsState,
	fromEngagements.getSelectedEngagementId
);

export const selectAllEngagements = createSelector(
	getEngagementsState,
	fromEngagements.selectEngagements
);

export const selectLatestEngagement = createSelector(
	selectAllEngagements,
	getSpecifiedEngagementId,
	(engagements, engagementId) => {
		let foundEngagement: BpasEngagement;
		if (engagementId) {
			foundEngagement = engagements.find(engagement => engagement.uniqueId === engagementId);
		} else {
			foundEngagement = engagements.find(engagement => engagement.flags.isActive);
		}
		return foundEngagement;
	}
);

export const getActiveEngagement = createSelector(
	selectAllEngagements,
	(engagements) => engagements.filter(engagement => get(engagement, 'flags.isActive'))
);
